import { render, staticRenderFns } from "./capitalHandOver.vue?vue&type=template&id=8240dc28&"
import script from "./capitalHandOver.vue?vue&type=script&lang=js&"
export * from "./capitalHandOver.vue?vue&type=script&lang=js&"
import style0 from "./capitalHandOver.vue?vue&type=style&index=0&id=8240dc28&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports